define('formkit/view/form.object/content/input.content.view',['require','exports','module','uikit/uikit','./base.input.content.view'],function (require, exports, module) {
  var UIKit                = require('uikit/uikit');
  var BaseInputContentView = require('./base.input.content.view');

  var PreviewAnswerView = BaseInputContentView.PreviewAnswerView.extend({
    internalViewOptions: BaseInputContentView.PreviewAnswerView.extendInternalViewOptions({
      inputView: function() {
        return {
          type: UIKit.Input,
          fluid: true
        }
      }
    }),

    onInputViewFocus: function() {
      this.form.triggerBeginEditAnswerEvent(this, this.model, {
        answerValueModel: this.getAndLinkAnswerValueModel(this.model, this.form)
      });
    },

    onInputViewBlur: function() {
      if (!(this.getOption('readonly'))) {
        this.form.triggerEndEditAnswerEvent(this, this.model, {
          answerValueModel: this.getAndLinkAnswerValueModel(this.model, this.form)
        });
      }
    }
  });

  var InputContentView = BaseInputContentView.extend({
    internalViewOptions: BaseInputContentView.extendInternalViewOptions({
      previewAnswerView: function() {
        return {
          type: PreviewAnswerView
        }
      }
    })
  });

  InputContentView.PreviewAnswerView = PreviewAnswerView;

  module.exports = InputContentView;
});

